import { render, staticRenderFns } from "./carStatusDistribution.vue?vue&type=template&id=3d8668dd&scoped=true&"
import script from "./carStatusDistribution.vue?vue&type=script&lang=js&"
export * from "./carStatusDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8668dd",
  null
  
)

export default component.exports